import React from 'react'
import { Box } from '@mui/system'
import { currencyFormatter } from '../../utils'
import { Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { PieValueType } from './ShopPieChart'

interface ShopCustomLegendProps {
  valueType: PieValueType
  totalValue: number
  filledValue: number
  totalValueLabel: string
  filledValueLabel: string
  filledColor: string
}

const useStyles = makeStyles()(theme => ({
  legendWrapper: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginLeft: theme.spacing(2),
    maxWidth: '140px',
  },
}))

/*
 * Component for custom legend in the shop pie chart.
 */
const ShopCustomLegend: React.FC<ShopCustomLegendProps> = ({
  valueType,
  totalValue,
  filledValue,
  totalValueLabel,
  filledValueLabel,
  filledColor,
}) => {
  const { classes } = useStyles()
  const formattedTotalValue = valueType === 'currency' ? currencyFormatter(totalValue) : totalValue
  const formattedFilledValue = valueType === 'currency' ? currencyFormatter(filledValue) : filledValue

  return (
    <Box className={classes.legendWrapper}>
      <Box sx={{ marginBottom: 6 }}>
        <Typography variant="subtitle2">{totalValueLabel}</Typography>
        <Typography variant="h3">{formattedTotalValue}</Typography>
      </Box>
      <Box>
        <Typography variant="subtitle2">{filledValueLabel}</Typography>
        <Typography variant="h3" color={filledColor}>
          {formattedFilledValue}
        </Typography>
      </Box>
    </Box>
  )
}

export default ShopCustomLegend
